import { Route } from "react-router-dom";
import EnableTenantAccessView from "src/views/global/EnableTenantAccessView";

const GlobalRoutes = [
	<Route
		element={<EnableTenantAccessView />}
		path="/enable-access"
		key="/enable-access"
	/>,
];

export default GlobalRoutes;
